import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    // "id": null,
    "loai_dt": null,
    "loai_tiep_xuc": null,
    "doi_tuong": {
        "ten": null,
        "so_dien_thoai": null,
        "id": null,
        "card_code": null,
        "cmt": null,
        "ho_chieu": null,
        "ngay_sinh": null,
        "gioi_tinh": null,
        "ma_quoc_tich": null,
        "quoc_tich": null,
        "ma_tinh": null,
        "ten_tinh": null,
        "ma_huyen": null,
        "ten_huyen": null,
        "ma_xa": null,
        "ten_xa": null,
        "thoi_gian_nhap_canh_tiep_xuc_cuoi": null,
        "dia_chi_luu_tru": null
    },
    "la_chu_ho": false,
    "tu_khai": false,
    "ngay_theo_doi": null,
    "ngay_ket_thuc_theo_doi":null,
    "thong_tin_chu_ho": {
        "ten": null,
        "so_dien_thoai": null,
        "ngay_sinh": null,
        "gioi_tinh": null,
        "card_code": null,
        "cmt": null,
        "ma_quoc_tich": null,
        "quoc_tich": null
    },
    "cb_theo_doi": {
        "id": null,
        "ho_ten": null
    },
    "co_so_cach_ly": {
        "ma_tinh": null,
        "ten_tinh": null,
        "ma_huyen": null,
        "ten_huyen": null,
        "ma_xa": null,
        "ten_xa": null,
        "ma_co_so": null,
        "ten_co_so": null,
        "dia_chi": null
    },
    "nguoi_lien_quan": [],
    "lich_su_di_chuyen": [],
    "loai_cach_ly": null
};

// validation form
model.validForm = {
    // "id": null,
    "loai_dt": [ValidService.required],
    "loai_tiep_xuc": [ValidService.required],
    "doi_tuong": {
        "ten": [ValidService.required],
        "so_dien_thoai": [ValidService.checkPhone],
        "id": [],
        "card_code": [ValidService.required],
        "cmt": [],
        "ho_chieu": [],
        "ngay_sinh": [],
        "gioi_tinh": [],
        "ma_quoc_tich": [],
        "quoc_tich": [],
        "ma_tinh": [],
        "ten_tinh": [],
        "ma_huyen": [],
        "ten_huyen": [],
        "ma_xa": [],
        "ten_xa": [],
        "thoi_gian_nhap_canh_tiep_xuc_cuoi": [ValidService.required],
        "dia_chi_luu_tru": []
    },
    "la_chu_ho": [],
    "tu_khai": [],
    "ngay_theo_doi": [],
    "ngay_ket_thuc_theo_doi":[],
    "thong_tin_chu_ho": {
        "ten": [],
        "so_dien_thoai": [ValidService.checkPhone],
        "ngay_sinh": [],
        "gioi_tinh": [],
        "card_code": [],
        "cmt": [],
        "ma_quoc_tich": null,
        "quoc_tich": []
    },
    "cb_theo_doi": {
        "id": [],
        "ho_ten": []
    },
    "co_so_cach_ly": {
        "ma_tinh": [],
        "ten_tinh": [],
        "ma_huyen": [],
        "ten_huyen": [],
        "ma_xa": [],
        "ten_xa": [],
        "ma_co_so": [],
        "ten_co_so": [],
        "dia_chi": []
    },
    "loai_cach_ly": []
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    nguoi_lien_quan: {
        "type": null,
        "ho_ten": null,
        "gioi_tinh": null,
        "noi_tiep_xuc": null,
        "sodt_nguoi_tiep_xuc": null,
        "cmt_nguoi_tiep_xuc": null,
        "ho_chieu": null,
        "ngay_sinh": null,
        "ma_quoc_tich": null,
        "quoc_tich": null,
        "ma_tinh": null,
        "ten_tinh": null,
        "ma_huyen": null,
        "ten_huyen": null,
        "ma_xa": null,
        "ten_xa": null,
        "dia_chi_nguoi_tiep_xuc": null,
        "khac": null
    },
    lich_su_di_chuyen: {
        "thoi_gian_tiep_xuc": {
            "bat_dau": null,
            "ket_thuc": null
        },
        "noi_tiep_xuc": null,
        "ho_ten": null,
        "sodt_nguoi_tiep_xuc": null,
        "gioi_tinh": null,
        "nam_sinh": null,
        "dia_chi_nguoi_tiep_xuc": null,
        "cmt_nguoi_tiep_xuc": null,
        "khac": null
    }

};

// validation các form khác
model.validFormOther = {

    nguoi_lien_quan: {
        "type": [ValidService.required],
        "ho_ten": [ValidService.required],
        "gioi_tinh": [],
        "noi_tiep_xuc": [],
        "sodt_nguoi_tiep_xuc": [ValidService.checkPhone],
        "cmt_nguoi_tiep_xuc": [],
        "ho_chieu": [],
        "ngay_sinh": [],
        "ma_quoc_tich": [],
        "quoc_tich": [],
        "ma_tinh": [],
        "ten_tinh": [],
        "ma_huyen": [],
        "ten_huyen": [],
        "ma_xa": [],
        "ten_xa": [],
        "dia_chi_nguoi_tiep_xuc": [],
        "khac": []
    },
    lich_su_di_chuyen: {
        "thoi_gian_tiep_xuc": {
            "bat_dau": [ValidService.required],
            "ket_thuc": [ValidService.required]
        },
        "noi_tiep_xuc": [],
        "ho_ten": [ValidService.required],
        "sodt_nguoi_tiep_xuc": [ValidService.checkPhone],
        "gioi_tinh": [],
        "nam_sinh": [],
        "dia_chi_nguoi_tiep_xuc": [],
        "cmt_nguoi_tiep_xuc": [],
        "khac": []
    }
};

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: true,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["register_date", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            'doi_tuong.so_dien_thoai': '',
            'doi_tuong.ten': '',
            'doi_tuong.cmt': '',
            'doi_tuong.card_code': '',
            'co_so_cach_ly.ma_co_so': '',
            'co_so_cach_ly.ma_xa': '',
            'co_so_cach_ly.ma_huyen': '',
            'co_so_cach_ly.ma_tinh': ''
        },
        valid: {},
        operator: {
            'doi_tuong.so_dien_thoai': ':regex:',
            'doi_tuong.ten': ':regex_i:',
            'doi_tuong.cmt': ':regex:'
        }
    }
};

export default model;